import "@assets/js/app.js"
import "../../assets/style/styles.scss"
import { mount } from 'svelte';
import App from "./App.svelte";
import {BizTextInsert} from "./components/TextInsert";
import {scrollBgScale} from "./components/Animation";


//CE
import Cta from "./custom-elements/Cta.svelte"
import PageHeader from "./custom-elements/PageHeader.svelte"

export const bizFeesOtherNumber = 130

document.addEventListener("DOMContentLoaded",()=> {
  const TOP = document.getElementById("biz-top")
  TOP? mount(App, { target: TOP }):null;

  BizTextInsert()
  scrollBgScale()
})
